/**
 * V68: 현재 고용계약 시작일/만료일 통합 헬퍼.
 *
 * SSoT 구조 ([functions/src/modules/hr/employmentHistorySync.ts:258-272]):
 *   currentEmploymentTypeCode 에 따라 users 컬렉션의 단 하나의 startDate/endDate 필드만 채워짐.
 *   - DISPATCH → dispatchHireDate / dispatchEndDate
 *   - CONTRACT → contractHireDate / contractEndDate
 *   - INTERN   → internHireDate   / internEndDate
 *   - REGULAR  → regularHireDate (입사일은 기록) / endDate 필드 없음
 *
 * 본 헬퍼는 currentEmploymentTypeCode 기반으로 적절한 필드를 선택하여
 * UI 표시용 문자열을 반환한다 (값 없으면 '-').
 *
 * 정책 (V68):
 *   - REGULAR 는 "계약" 개념이 아니므로 계약시작일/계약만료일 모두 '-' 반환.
 *   - 최초 입사일은 firstHireDate / 정규직 환산 입사일은 ngleFirstHireDate 별도 필드 사용.
 */

export interface EmploymentDateSource {
  currentEmploymentTypeCode?: string | null;
  /** DISPATCH 직원의 파견 시작일 */
  dispatchHireDate?: string | null;
  /** DISPATCH 직원의 파견 만료일 */
  dispatchEndDate?: string | null;
  /** CONTRACT 직원의 계약 시작일 */
  contractHireDate?: string | null;
  /** CONTRACT 직원의 계약 만료일 */
  contractEndDate?: string | null;
  /** INTERN 직원의 인턴 시작일 */
  internHireDate?: string | null;
  /** INTERN 직원의 인턴 만료일 */
  internEndDate?: string | null;
}

/** 하위 호환: 기존 만료일 전용 source alias */
export type EmploymentEndDateSource = EmploymentDateSource;

/**
 * 현재 고용계약 만료일 (UI 표시용 문자열).
 * REGULAR 직원 또는 값 없음 → '-' 반환.
 */
export function getCurrentEmploymentEndDate(emp: EmploymentDateSource): string {
  const code = (emp.currentEmploymentTypeCode || '').toUpperCase();
  if (code === 'DISPATCH') return emp.dispatchEndDate || '-';
  if (code === 'CONTRACT') return emp.contractEndDate || '-';
  if (code === 'INTERN') return emp.internEndDate || '-';
  return '-';
}

/**
 * 현재 고용계약 시작일 (UI 표시용 문자열).
 *
 * 정책: REGULAR 는 "계약" 개념이 아니므로 '-' 반환.
 *   (최초 입사일은 firstHireDate / ngleFirstHireDate 별도 컬럼 사용)
 */
export function getCurrentEmploymentStartDate(emp: EmploymentDateSource): string {
  const code = (emp.currentEmploymentTypeCode || '').toUpperCase();
  if (code === 'DISPATCH') return emp.dispatchHireDate || '-';
  if (code === 'CONTRACT') return emp.contractHireDate || '-';
  if (code === 'INTERN') return emp.internHireDate || '-';
  return '-';
}
